export class DropDownSerializableValue {
  value?: string;

  constructor(value?: string) {
    this.value = value;
  }
}
